import React, { useState } from 'react';
import { Button, Modal, Image, Divider, Space } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import type { OrderForTableReceive } from '../types';

interface CheckOrderDetailProps {
  order: OrderForTableReceive;
}

const iconStyle = {
  fontSize: '17px',
  color: '#209BFA',
};

const CheckOrderDetail = ({ order }: CheckOrderDetailProps) => {
  const {
    itemName,
    expirationTime,
    allergen,
    cost,
    storageMethod,
    manufacturerName,
    manufacturerPhone,
    manufacturerAddress,
    itemIntroduction,
    itemSpec,
    notice,
    note,
    imgUrl,
    maximumAmount,
    startTime,
    endTime,
  } = order;

  const [isOpenCheckDetailModal, setIsOpenCheckDetailModal] = useState(false);

  return (
    <>
      <Modal
        open={isOpenCheckDetailModal}
        onCancel={() => setIsOpenCheckDetailModal(false)}
        footer={[
          <Button
            key="back"
            type="primary"
            onClick={() => setIsOpenCheckDetailModal(false)}
          >
            確認
          </Button>,
        ]}
      >
        <Image
          width="100%"
          src={imgUrl !== '' ? imgUrl : '/ezcon.png'}
          preview={false}
        />
        <Divider />
        <h1>{itemName}</h1>
        <Divider />
        {note !== '' ? (
          <>
            <Space direction="vertical">
              <Space>
                <NotificationOutlined style={iconStyle} />
                <h4 className={styles.sectionTitle}>最新消息：</h4>
              </Space>
              <div>
                <h5 className={styles.contentTitle}>最新消息</h5>
                <p>{note}</p>
              </div>
            </Space>
            <Divider />
          </>
        ) : null}
        <Space direction="vertical">
          <Space>
            <NotificationOutlined style={iconStyle} />
            <h4 className={styles.sectionTitle}>團購資訊：</h4>
          </Space>
          <div>
            <h5 className={styles.contentTitle}>團購起始時間</h5>
            <p>{startTime}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>團購截止時間</h5>
            <p>{endTime}</p>
          </div>
        </Space>
        <Divider />
        <Space direction="vertical">
          <Space>
            <NotificationOutlined style={iconStyle} />
            <h4 className={styles.sectionTitle}>商品資訊：</h4>
          </Space>
          <div>
            <h5 className={styles.contentTitle}>賞味期限</h5>
            <p>{expirationTime}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>過敏原</h5>
            <p>{allergen}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>保存方法</h5>
            <p>{storageMethod}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>廠商名稱</h5>
            <p>{manufacturerName}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>廠商電話</h5>
            <p>{manufacturerPhone}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>廠商地址</h5>
            <p>{manufacturerAddress}</p>
          </div>
        </Space>
        <Divider />
        <Space direction="vertical">
          <Space>
            <NotificationOutlined style={iconStyle} />
            <h4 className={styles.sectionTitle}>商品資訊：</h4>
          </Space>
          <div>
            <h5 className={styles.contentTitle}>商品介紹</h5>
            <p>{itemIntroduction}</p>
          </div>
          <div>
            <h5 className={styles.contentTitle}>商品包含</h5>
            <p>{itemSpec}</p>
          </div>
        </Space>
        <Divider />
        <Space direction="vertical">
          <Space>
            <NotificationOutlined style={iconStyle} />
            <h4 className={styles.sectionTitle}>注意事項：</h4>
          </Space>
          <div>
            <h5 className={styles.contentTitle}>注意事項</h5>
            <p>{notice}</p>
          </div>
        </Space>
        <Divider />
        <Space direction="vertical" className={styles.orderPlanWrapper}>
          <Space>
            <NotificationOutlined style={iconStyle} />
            <h4 className={styles.sectionTitle}>團購方案：</h4>
          </Space>
          <div className={styles.planInfoContainer}>
            <div>
              <h5 className={styles.contentTitle}>方案</h5>
              <p>{itemName}</p>
            </div>
            <div>
              <h5 className={styles.contentTitle}>{`${
                cost[0].amount ? cost[0].type : cost[1].type
              }金額`}</h5>
              <p>
                {cost[0].amount
                  ? `NT$ ${cost[0].amount}`
                  : `${cost[1].amount}點`}
              </p>
            </div>
            <div>
              <h5 className={styles.contentTitle}>數量</h5>
              <p>{maximumAmount}</p>
            </div>
          </div>
        </Space>
      </Modal>
      <Button type="primary" onClick={() => setIsOpenCheckDetailModal(true)}>
        查看
      </Button>
    </>
  );
};

export default CheckOrderDetail;
